import dayjs from 'dayjs';
import { getBusinessInfo } from './getBusinessInfo';
import { localTimeToServer } from './timer';

// 解析日期函数默认值 如 "month(-1),15" ==> 上个月15号  "week(-1),friday" ==> 上周五
export function setTimeValue() {
    let timeObj = {};
    const dayArr = ['day(-1)', 'day(0)', 'day(1)'];
    const monthArr = ['month(-1)', 'month(0)', 'month(1)'];
    const weekArr = ['week(-1)', 'week(0)', 'week(1)'];
    const weekdayArr = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    const dayMap = {
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6,
        sunday: 7,
    };
    for (let index = 0; index < monthArr.length; index++) {
        const element = monthArr[index];
        for (let day = 1; day < 32; day++) {
            timeObj['#' + element + ',' + day + '#'] = {
                hide: true,
                value: (attr = {}) => {
                    let { isconverttimezones } = attr;
                    let monthArr = element.replace(')', '').split('(');
                    let [month, diff] = monthArr;
                    // let dayPart = dayjs().add(diff, month).startOf('month').add(day - 1, 'day').format('YYYY-MM-DD hh:mm:ss');
                    // let timePart = getBaseTime();
                    return localTimeToServer(dayjs(getDefaultBaseDate()).add(diff, month).startOf('month').add(day - 1, 'day'), isconverttimezones).format('YYYY-MM-DD hh:mm:ss');
                },
                display: () => {
                    let monthArr = element.replace(')', '').split('(');
                    let [month, diff] = monthArr;
                    // let dayPart = dayjs().add(diff, month).startOf('month').add(day - 1, 'day').format('YYYY-MM-DD');
                    // let timePart = getBaseTime();
                    return dayjs(getDefaultBaseDate()).add(diff, month).startOf('month').add(day - 1, 'day').format('YYYY-MM-DD hh:mm:ss');
                },
            };
        }
    }
    for (let index = 0; index < weekArr.length; index++) {
        const element = weekArr[index];
        for (let day = 0; day < weekdayArr.length; day++) {
            const dayElement = weekdayArr[day];
            timeObj['#' + element + ',' + dayElement + '#'] = {
                hide: true,
                value: (attr = {}) => {
                    let { isconverttimezones } = attr;
                    let weekArr = element.replace(')', '').split('(');
                    let [week, diff] = weekArr;
                    // let dayPart = dayjs().add(diff, week).startOf('week').add(dayMap[dayElement], 'day').format('YYYY-MM-DD');
                    // let timePart = getBaseTime();
                    return localTimeToServer(dayjs(getDefaultBaseDate()).add(diff, week).startOf('week').add(dayMap[dayElement], 'day'), isconverttimezones).format('YYYY-MM-DD hh:mm:ss');
                },
                display: () => {
                    let weekArr = element.replace(')', '').split('(');
                    let [week, diff] = weekArr;
                    // let dayPart = dayjs().add(diff, week).startOf('week').add(dayMap[dayElement], 'day').format('YYYY-MM-DD');
                    // let timePart = getBaseTime();
                    return dayjs(getDefaultBaseDate()).add(diff, week).startOf('week').add(dayMap[dayElement], 'day').format('YYYY-MM-DD hh:mm:ss');
                },
            };
        }
    }
    for (let index = 0; index < dayArr.length; index++) {
        const element = dayArr[index];
        timeObj['#' + element + '#' + ',' ] = {
            hide: true,
            value: (attr = {}) => {
                let { isconverttimezones } = attr;
                let daysArr = element.replace(')', '').split('(');
                let [ , diff] = daysArr;
                // let dayPart = dayjs().add(diff, 'day').format('YYYY-MM-DD');
                // let timePart = getBaseTime();
                return localTimeToServer(dayjs(getDefaultBaseDate()).add(diff, 'day'), isconverttimezones).format('YYYY-MM-DD hh:mm:ss');
            },
            display: () => {
                let daysArr = element.replace(')', '').split('(');
                let [ , diff] = daysArr;
                // let dayPart = dayjs().add(diff, 'day').format('YYYY-MM-DD');
                // let timePart = getBaseTime();
                return dayjs(getDefaultBaseDate()).add(diff, 'day').format('YYYY-MM-DD hh:mm:ss');
            },
        };
    }
    timeObj['@BIZDATE'] = {
        hide: true,
        value: getBusinessInfo()?.businessDate,
        display: getBusinessInfo()?.businessDate,
    };
    
    return timeObj;
}

// 获取当前时分秒
export function getBaseTime(){
    return getBusinessInfo()?.businessDate?.split(' ')?.[1] || dayjs().format('HH:mm:ss');
}
function getDefaultBaseDate(){
    return getBusinessInfo()?.businessDate || dayjs().format('YYYY-MM-DD');
}
